module.exports = __webpack_public_path__ + "img/icon3.92efd677.png";